// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_MAIN_FEATURE_MAXIMUM_LOAD_PER_CHILD_IN_kg = "Nosnos\u0165 %(kg)s kg (die\u0165a)";
export const STROLLER_MAIN_FEATURES = "Hlavn\u00e9 parametre";
export const STROLLER_MAIN_FEATURE_STROLLER_FOR_PARENT_BY_HEIGHT_TALL = "Pre vysok\u00fdch rodi\u010dov";
export const STROLLER_MAIN_FEATURE_UNFOLDED_DIMENSIONS_IN_cm_WIDTH = "\u0160\u00edrka do v\u00fd\u0165ahu %(cm)s cm";
export const STROLLER_MAIN_FEATURE_WEIGHT_IN_kg = "Hmotnos\u0165 %(kg)s kg";
export const STROLLER_SEARCH_FORM_VERY_GOOD_FOLDING = "Ve\u013emi dobre skladn\u00fd";
export const STROLLER_TYPE_CHECKED_BAGGAGE = "Cestovn\u00fd";
export const STROLLER_TYPE_CITY_TERRAIN = "Mestsk\u00fd";
export const STROLLER_TYPE_COUNTRYSIDE_TERRAIN = "Dedina";
export const STROLLER_TYPE_HARD_TERRAIN = "Ter\u00e9nny";
export const STROLLER_TYPE_SPORT_RUNNING = "Beh a \u0161port";
